import React from 'react';
import bitLabsLogo from '../../images/user/avatar/bitlabslogo_clean.svg';
import './TestFooter.css';

const TestFooter = () => {
  return (
    <div className="test-footer-container">
      {/* Left side: Logo + Copyright & Privacy Policy */}
      <div className="test-footer-left">
        <img
          src={bitLabsLogo}
          alt="bitLabs"
          className="test-footer-logo"
          onError={(e) => {
            e.currentTarget.src = "/images/logo.png";
          }}
        />
        <span>
          © 2026 Symphonize, Inc. All rights reserved.
          <a href="https://bitlabs.in/privacy-and-policy?"> Privacy Policy</a>
        </span>
      </div>

      {/* Right side: Support link */}
      <div className="test-footer-right">
        Reach out for expert{' '}
        <a
          href="mailto:nagulmeera.shaik@tekworks.in"
          className="test-footer-support-link"
        >
          SUPPORT
        </a>
      </div>
    </div>
  );
};

export default TestFooter;
